// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tkkS","input":"styles_input__1A1Vi"};